import React from "react";

import { Badge, BadgeText } from "@/components/atoms/Badge";
import { Box } from "@/components/atoms/Box";
import { Text } from "@/components/atoms/Text";

/* design-system: dynamic-style waiver — data-driven value (header tint color from navigation prop) */
const headerTextStyle = (color: string) => ({ color }) as const;

/**
 * View component for HeaderTitleWithBadge.
 * Renders a header title with an experimental badge.
 * @param props - Component props
 * @param props.title - The title text to display
 * @param props.headerTintColor - Color for the title text
 */
const HeaderTitleWithBadgeView = ({
  title,
  headerTintColor,
}: {
  title: string;
  headerTintColor: string;
}) => (
  <Box className="flex-row items-center gap-2">
    <Text
      // eslint-disable-next-line no-restricted-syntax -- data-driven navigation headerTintColor; arbitrary runtime color, no closed token
      UNSAFE_style={headerTextStyle(headerTintColor)}
      variant="title-sm"
    >
      {title}
    </Text>
    <Badge action="warning" size="sm" variant="solid">
      <BadgeText>EXPERIMENTAL</BadgeText>
    </Badge>
  </Box>
);

HeaderTitleWithBadgeView.displayName = "HeaderTitleWithBadgeView";

export default React.memo(HeaderTitleWithBadgeView);
